import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { Session } from "../utils/session";

export default function Peersheet() {

  const navigate = useNavigate();
  const location = useLocation();

  const { sheetName, workspaceId } = location.state || {};

  const [showModal, setShowModal] = useState(true);
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
const [doctors, setDoctors] = useState([]);
  const [form, setForm] = useState({
    doctorName: "",
    date: "",
    caseID: "",
    userName: "",
    page: "",
    qc: ""
  });

  // 🔹 Protect Route
  useEffect(() => {
    if (!location.state?.fromAddCard) {
      navigate("/dailytask");
    }
  }, [location, navigate]);

  // 🔹 Load Tabs
  useEffect(() => {

    if (!sheetName) return;

    fetch(
      `${API_BASE_URL}/api/GoogleSheet/tabs?sheetName=${encodeURIComponent(sheetName)}`,
      {
        headers: {
          Authorization: `Bearer ${Session.getToken()}`
        }
      }
    )
      .then(res => res.json())
      .then(data => setTabs(Array.isArray(data) ? data : []))
      .catch(err => console.error("Tab load error:", err));

  }, [sheetName]);

  // 🔹 Disable Scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => document.body.style.overflow = "auto";
  }, []);

  // 🔹 Handle Change
  const handleChange = (e) => {

    const { name, value } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 🔹 Close
  const closeModal = () => {
    setShowModal(false);
    navigate(-1);
  };
  useEffect(() => {

    fetch(`${API_BASE_URL}/api/GoogleSheet/doctors-list`, {
      headers: {
        Authorization: `Bearer ${Session.getToken()}`
      }
    })
      .then(res => res.json())
      .then(data => setDoctors(Array.isArray(data) ? data : []))
      .catch(err => console.error("Doctor load error:", err));

  }, []);

  // 🔹 Save
  const handleSave = async () => {

    if (!selectedTab) {
      alert("Please Select Tab ❗");
      return;
    }

    if (!form.doctorName || !form.caseID) {
      alert("Doctor & CaseID Required ❗");
      return;
    }

    const payload = {

      DoctorName: form.doctorName || null,
      Date: form.date || null,
      CaseID: form.caseID || null,
      UserName: form.userName || null,
      Page: form.page ? Number(form.page) : null,
      QC: form.qc || null,

      WorkspaceID: Number(workspaceId),
      TabName: selectedTab,
      SheetName: sheetName
    };

    try {

      const res = await fetch(`${API_BASE_URL}/api/Cards/create-PEER`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Session.getToken()}`
        },
        body: JSON.stringify(payload)
      });

      const result = await res.text();
      console.log("API Response:", result);

      if (!res.ok) {
        throw new Error(result);
      }

      alert("Saved Successfully ✅");

      closeModal();

    } catch (err) {
      console.error("Save Error:", err);
      alert("Save Failed ❌\n" + err.message);
    }
  };


  if (!showModal) return null;

  return (
    <>

      {/* BACKDROP */}
      <div className="modal-backdrop fade show"></div>

      {/* MODAL */}
      <div className="modal fade show" style={{ display: "block" }}>

        <div className="modal-dialog modal-dialog-centered modal-lg">

          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header bg-light">
              <h5 className="fw-bold">Add PEERS Sheet</h5>

              <button
                className="btn-close"
                onClick={closeModal}
              ></button>
            </div>


            {/* BODY */}
            <div className="modal-body">

              <div className="row g-3">

                {/* TAB */}
                <div className="col-md-6">
                  <label>Sheet Tab</label>

                  <select
                    className="form-select"
                    value={selectedTab}
                    onChange={(e) => setSelectedTab(e.target.value)}
                  >
                    <option value="">Select Tab</option>

                    {tabs.map((t, i) => (
                      <option key={i} value={t}>{t}</option>
                    ))}
                  </select>
                </div>


                {/* DOCTOR */}
                 <div className="col-md-6">
      <label>Doctor Name</label>
      <select
        className="form-select"
        name="doctorName"
        value={form.doctorName}
        onChange={handleChange}
      >
        <option value="">Select Doctor</option>
        {doctors.map((d, i) => (
          <option key={i} value={d}>{d}</option>
        ))}
      </select>
    </div>

                {/* DATE */}
                <div className="col-md-6">
                  <label>Date</label>

                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    value={form.date}
                    onChange={handleChange}
                  />
                </div>


                {/* CASE ID */}
                <div className="col-md-6">
                  <label>Case ID</label>

                  <input
                    className="form-control"
                    name="caseID"
                    value={form.caseID}
                    onChange={handleChange}
                  />
                </div>


                {/* USER */}
                <div className="col-md-6">
                  <label>User Name</label>

                  <input
                    className="form-control"
                    name="userName"
                    value={form.userName}
                    onChange={handleChange}
                  />
                </div>


                {/* PAGE */}
                <div className="col-md-6">
                  <label>Page</label>

                  <input
                    type="number"
                    className="form-control"
                    name="page"
                    value={form.page}
                    onChange={handleChange}
                  />
                </div>


                {/* QC */}
                <div className="col-md-6">
                  <label>QC</label>

                  <input
                    className="form-control"
                    name="qc"
                    value={form.qc}
                    onChange={handleChange}
                  />
                </div>

              </div>

            </div>


            {/* FOOTER */}
            <div className="modal-footer bg-light">

              <button
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save
              </button>

            </div>

          </div>

        </div>

      </div>

    </>
  );
}
